import style from "./apptopicbanner.module.scss";
import classNames from "classnames";
import useAppModernisation from "../../hooks/useAppModernisation";
import GuidelineChip from "../Guideline/GuidelineChip";
import useGoBack from "../../hooks/useGoBack";

function getIconClassName(topicDetails) {
  if (topicDetails) {
    return classNames("squareIcon", "smallSquare", topicDetails.squareIconClass);
  }
  return classNames("squareIcon");
}

const AppTopicHeadline = ({ topicDetails, bannerText }) => {
  const { goBack } = useGoBack();
  const { isWebModernisationEnabled } = useAppModernisation();
  const breadCrumbCaratClasses = classNames(style.breadcrumbCarat, "tg-icons-Carat");
  // I leave the logic but 18 for long / short is Ok
  const iconClassNames = getIconClassName(topicDetails);
  const headerClassName = classNames(
    `${bannerText}`.length > 20 ? "size-18" : "size-18",
    "semibold",
  );

  return (
    <div className={style.headline}>
      <h1 className={headerClassName}>{bannerText}</h1>
      {isWebModernisationEnabled ? (
        <div className={style.chipContainer}>
          <GuidelineChip
            iconClassSuffix={topicDetails?.squareIconClass}
            linkText={topicDetails?.text}
            onClickProps={topicDetails?.onClickProps}
            showArrowIcon={false}
          />
        </div>
      ) : (
        <div
          className={classNames(style.titleBreadcrumb, "semibold", "size-12")}
          onClick={goBack}
          role="button"
          aria-label={`${topicDetails?.text}-breadcrumb`}
        >
          <span className={iconClassNames} />
          <span className={style.descriptionBreadcrumb}>{topicDetails?.text}</span>
          <span className={breadCrumbCaratClasses}></span>
        </div>
      )}
    </div>
  );
};

export default AppTopicHeadline;
